// extracted by mini-css-extract-plugin
export var completionBody = "_ll-2";
export var completionCard = "_ll-0";
export var completionFooter = "_ll-3";
export var completionTitle = "_ll-1";